import React from "react";
import {
  useTheme,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Grid,
  FormControl,
  NativeSelect,
  FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";

const BulkUpdatePopup = ({
  openPopup,
  setOpenPopup,
  title,
  sortedData,
  custodians,
  setEditableData,
  setHasChanges,
}) => {
  const theme = useTheme();

  const formik = useFormik({
    initialValues: {
      broker: "",
      account: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.broker) {
        errors.broker = "Please select a broker.";
      }
      if (!values.account) {
        errors.account = "Please select an account.";
      }
      return errors;
    },
    onSubmit: () => {},
  });

  const handleCancel = () => {
    formik.resetForm();
    setOpenPopup(false);
  };

  const handleBrokerChange = (event) => {
    const newValue = event.target.value;
    formik.setFieldValue("broker", newValue);

    // Update editable data dynamically
    setEditableData((prev) =>
      prev.map((item) => ({
        ...item,
        broker: newValue,
      }))
    );
    setHasChanges(true);
  };

  const handleAccountChange = (event) => {
    const newValue = event.target.value;
    formik.setFieldValue("account", newValue);

    // Update editable data dynamically
    setEditableData((prev) =>
      prev.map((item) => ({
        ...item,
        account: newValue,
      }))
    );
    setHasChanges(true);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      onClose={handleCancel}
      open={openPopup}
      sx={{
        "& .css-1t1j96h-MuiPaper-root-MuiDialog-paper": {
          minWidth: "200px",
          marginLeft: "200px",
        },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex" }}>
          <Typography
            variant="h6"
            component="div"
            align="left"
            style={{ flexGrow: 1, fontSize: "20px" }}
          >
            {title}
          </Typography>
          <IconButton onClick={handleCancel}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <FormControl fullWidth>
              <NativeSelect
                value={formik.values.broker}
                onChange={handleBrokerChange}
                id="broker"
                name="broker"
                error={Boolean(formik.errors.broker && formik.touched.broker)}
              >
                <option value="">Select Broker</option>
                {sortedData?.map((val) => (
                  <option key={val.abbreviation} value={val.abbreviation}>
                    {val.abbreviation}
                  </option>
                ))}
              </NativeSelect>
              {formik.errors.broker && formik.touched.broker && (
                <FormHelperText error>{formik.errors.broker}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <NativeSelect
                value={formik.values.account}
                onChange={handleAccountChange}
                id="account"
                name="account"
                error={Boolean(formik.errors.account && formik.touched.account)}
              >
                <option value="">Select Account</option>
                {custodians?.map((val) => (
                  <option key={val.custodian} value={val.name}>
                    {val.name}
                  </option>
                ))}
              </NativeSelect>
              {formik.errors.account && formik.touched.account && (
                <FormHelperText error>{formik.errors.account}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default BulkUpdatePopup;
